import { Server } from "lucide-react";

const STEPS = [
  ["Afzenders instellen", <>CRM &amp; mailen → <b>Afzenders</b>: vul je Hostnet-adressen in, één per regel (maximaal 5). Elke lead krijgt vast één adres, ook voor Mail 2 en 3.</>],
  ["Wachtwoorden invullen", <>Ga naar <b>Verzenden via Hostnet</b> en vul per adres het Hostnet-wachtwoord in → <b>Opslaan &amp; testen</b>. Je ziet "verbonden" als het lukt. Het wachtwoord wordt versleuteld opgeslagen en nooit getoond.</>],
  ["Eerst zelf testen", <>Maak een test-lead met je eigen privé-adres (bijv. als penningmeester@) en plan één Toestemmingsmail in. Controleer of hij binnenkomt en of hij in je <b>Verzonden-map</b> in Outlook staat.</>],
  ["Toestemmingsmail inplannen", <>Kies leads in de tabel → <b>Inplannen via Hostnet</b> → <b>Toestemmingsmail</b>, of plan in voor het hele profiel. Alleen leads met een bekende <b>functie of naam</b> (zoals penningmeester@) komen in aanmerking. De aanhef wordt automatisch "Beste Jan Jansen" of "Beste penningmeester".</>],
  ["Antwoord verwerken", <>Antwoordt iemand "ja"? Klik in de tabel op <b>Toestemming ✓</b>. Bij "nee": klik <b>Nee</b>, dan krijgt de lead geen mails meer. Met de snelfilters <b>Toestemming gevraagd</b> en <b>Toestemming gegeven</b> vind je ze snel terug.</>],
  ["Mail 1, 2 en 3", <>Leads met toestemming plan je zelf in voor Mail 1, en later Mail 2 en 3, op dezelfde manier. Leads zonder toestemming worden automatisch overgeslagen.</>],
];

export const HostnetSteps = () => (
  <div data-testid="guide-hostnet" className="mt-8 rounded-xl border border-slate-200 p-5">
    <div className="flex items-center gap-2 mb-1">
      <Server className="w-4 h-4 text-[#FF4500]" strokeWidth={2} />
      <h3 className="font-display text-lg font-bold text-slate-900">Route A — Versturen via je eigen Hostnet-mailbox (aanbevolen)</h3>
    </div>
    <p className="text-sm text-slate-600 mb-4">
      De app logt in op je eigen Hostnet-mailbox, net als Outlook, en verstuurt in een rustig tempo. Er zit geen verzenddienst tussen.
      Een mail staat pas op <b>verzonden</b> als Hostnet hem heeft aangenomen, zodat je altijd precies weet wat er de deur uit is.
    </p>
    <ol className="space-y-3">
      {STEPS.map(([title, body], i) => (
        <li key={title} className="flex gap-3 text-sm">
          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-slate-900 text-white text-xs font-bold">{i + 1}</span>
          <div><div className="font-semibold text-slate-900">{title}</div><div className="text-slate-600 leading-relaxed">{body}</div></div>
        </li>
      ))}
    </ol>
    <div className="mt-4 grid gap-2 sm:grid-cols-2 text-xs">
      <div className="rounded-lg bg-slate-50 p-3 text-slate-600">
        <div className="font-semibold text-slate-900 mb-1">Tempo (instelbaar)</div>
        Werkdagen 9:00–17:00, per adres één mail per 3–6 minuten (willekeurig), maximaal 40 per dag per adres.
        Buiten die tijden wacht de wachtrij gewoon tot de volgende werkdag.
      </div>
      <div className="rounded-lg bg-slate-50 p-3 text-slate-600">
        <div className="font-semibold text-slate-900 mb-1">Overzicht &amp; veiligheid</div>
        In <b>Verzenden via Hostnet</b> zie je de wachtrij, wat vandaag per adres verzonden is en wat mislukt is.
        Met <b>Pauzeer</b> stop je tijdelijk; met <b>Noodstop</b> annuleer je alles wat nog in de wachtrij staat.
      </div>
      <div className="rounded-lg bg-slate-50 p-3 text-slate-600">
        <div className="font-semibold text-slate-900 mb-1">Onderwerpen testen</div>
        Geef per mail 1–5 onderwerpen op in de sjablonen. Elke lead krijgt er willekeurig één. Bij <b>Per onderwerp</b> zie je welk onderwerp de meeste reacties en klanten oplevert.
      </div>
      <div className="rounded-lg bg-slate-50 p-3 text-slate-600">
        <div className="font-semibold text-slate-900 mb-1">Afmelden &amp; mislukt</div>
        Elke mail heeft een afmeldlink. Wie zich afmeldt, krijgt nooit meer iets. Staat een mail op "mislukt", controleer dan eerst je Verzonden-map voordat je hem opnieuw inplant.
      </div>
    </div>
  </div>
);
